export default [
  'bm',
  'ca',
  'gl',
  'pm',
  'us',
  'bz',
  'cr',
  'gt',
  'hn',
  'mx',
  'ni',
  'pa',
  'sv',
  'ag',
  'ai',
  'aw',
  'bb',
  'bl',
  'bq',
  'bs',
  'cu',
  'cw',
  'dm',
  'do',
  'gd',
  'gp',
  'ht',
  'jm',
  'kn',
  'ky',
  'lc',
  'mf',
  'mq',
  'ms',
  'pr',
  'sx',
  'tc',
  'tt',
  'vc',
  'vg',
  'vi',
  'an',
  'ar',
  'bo',
  'br',
  'cl',
  'co',
  'ec',
  'fk',
  'gf',
  'gy',
  'pe',
  'py',
  'sr',
  'uy',
  've',
  'dz',
  'eg',
  'eh',
  'ly',
  'ma',
  'sd',
  'ss',
  'tn',
  'ea',
  'ic',
  'bf',
  'bj',
  'ci',
  'cv',
  'gh',
  'gm',
  'gn',
  'gw',
  'lr',
  'ml',
  'mr',
  'nam',
  'ne',
  'ng',
  'sh',
  'sl',
  'sn',
  'tg',
  'ao',
  'cd',
  'cf',
  'cg',
  'cm',
  'ga',
  'gq',
  'st',
  'td',
  'bi',
  'dj',
  'er',
  'et',
  'ke',
  'km',
  'mg',
  'mu',
  'mw',
  'mz',
  're',
  'rw',
  'sc',
  'so',
  'tz',
  'ug',
  'yt',
  'zm',
  'zw',
  'bw',
  'ls',
  'na',
  'sz',
  'za',
  'eu',
  'gg',
  'im',
  'je',
  'ax',
  'dk',
  'ee',
  'fi',
  'fo',
  'gb',
  'en',
  'ie',
  'is',
  'lt',
  'lv',
  'no',
  'se',
  'sj',
  'at',
  'be',
  'ch',
  'de',
  'fr',
  'li',
  'lu',
  'mc',
  'nl',
  'bg',
  'by',
  'cz',
  'hu',
  'md',
  'pl',
  'ro',
  'ru',
  'sk',
  'ua',
  'ad',
  'al',
  'ba',
  'es',
  'gi',
  'gr',
  'hr',
  'it',
  'me',
  'mk',
  'mt',
  'rs',
  'pt',
  'si',
  'sm',
  'va',
  'xk',
  'ae',
  'am',
  'az',
  'bh',
  'cy',
  'ge',
  'il',
  'iq',
  'jo',
  'kw',
  'lb',
  'om',
  'ps',
  'qa',
  'sa',
  'sy',
  'tr',
  'ye',
  'tm',
  'tj',
  'kg',
  'kz',
  'uz',
  'cn',
  'hk',
  'jp',
  'kp',
  'kr',
  'mn',
  'mo',
  'tw',
  'af',
  'bd',
  'bt',
  'in',
  'ir',
  'lk',
  'mv',
  'np',
  'pk',
  'bn',
  'id',
  'kh',
  'la',
  'mm',
  'my',
  'ph',
  'sg',
  'th',
  'tl',
  'vn',
  'qo',
  'au',
  'nf',
  'nz',
  'fj',
  'nc',
  'pg',
  'sb',
  'vu',
  'fm',
  'gu',
  'ki',
  'mh',
  'mp',
  'nr',
  'pw',
  'as',
  'ck',
  'nu',
  'pf',
  'pn',
  'tk',
  'to',
  'tv',
  'wf',
  'ws',
  'aq',
  'bv',
  'cc',
  'cx',
  'gs',
  'hm',
  'io',
  'tf',
  'um',
  'ac',
  'cp',
  'dg',
  'ta',
  'zz',
  'cis',
  'tpe',
  'asean'
];
